import * as React from 'react';
import * as styles from "./AIAssistant.css";
import { Helper } from '../../Helper';
import { LocalizationService } from '../../services/LocalizationService';
import { IFontSlots } from '../../interfaces/IFontSlots';

export interface IProps {
  hightlightColor: string;
  reply: string;
  fontSlots?: IFontSlots;
  sources?: { title: string, link: string }[];
}

export default class AiAssistantPanel extends React.Component<IProps> {
  private localizationService = new LocalizationService();

  public render() {
    return (
      <div
        className={styles.IA_aiResponseCardWrapper}
        style={{
          fontFamily: this.props.fontSlots?.body?.fontFamily
        }}
      >
        <div className={styles.IA_aiResponseCard}>
          <div style={{ whiteSpace: 'pre-wrap' }}>{this.props.reply}</div>
          {this.props.sources?.length > 0 &&
            <>
              <div className={styles.IA_aiResponseCardSourcesText} style={{ color: this.props.hightlightColor }}>{this.localizationService.strings.Navigator_Content_AiSources ?? "Sources"}</div>
              <div className={styles.IA_aiResponseCardSourcesWrapper} style={{ marginBottom: -5 }}>
                {this.props.sources.map(source => {
                  return <a
                    href={source.link}
                    target="_blank"
                    data-interception="off"
                    className={styles.IA_aiResponseCardSource}
                    style={{
                      backgroundColor: Helper.getColorWithOpacity(this.props.hightlightColor, 0.1, "#e0e0e0"),
                      color: this.props.hightlightColor
                    }}
                  >
                    {source.title}
                  </a>
                })}
              </div>
            </>
          }
        </div>
      </div>
    );
  }
}